import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';

@Component({
    selector: 'app-test-page',
    templateUrl: './test-page.component.html',
    styleUrls: ['./test-page.component.scss']
})
export class TestPageComponent implements OnInit  {

    items: any[] = [{title: 'c1'}, {title: 'c2'}, {title: 'c3'}, {title: 'c4'}, {title: 'c5'}, {title: 'c6'}, {title: 'c7'}, {title: 'c8'}, {title: 'c9'}, {title: 'c10'}];
    // items: any[] = [{title: 'c1'}, ];



    constructor() {}

    ngOnInit(): void {}






}
